import React from 'react';
import {Link, SxProps, Table, TableBody, TableCell, TableHead, TableRow, Typography} from "@mui/material"
import {TimeUtil} from "../../library/TimeUtil"
import {ProjectJson} from "../../api/json/ProjectJson"
import {Link as RouterLink} from "react-router-dom";

function AdminProjectsTable({ projects, total, sx }: {projects?: ProjectJson[], total?: number, sx?: SxProps}) {
    return (
        <>
            {total && <Typography variant="caption" gutterBottom>{total} projects</Typography>}
            <Table size="small" sx={sx}>
                <TableHead>
                    <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell>Updated</TableCell>
                        <TableCell># Training Rows</TableCell>
                        <TableCell># Validation Rows</TableCell>
                        <TableCell># Fine-tunes</TableCell>
                        <TableCell>Columns</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {projects?.map(project =>
                        <TableRow key={project.id}>
                            <TableCell>
                                <Typography variant="subtitle1">
                                    <Link component={RouterLink} to={`/admin/projects/${project.id}`}>{project.name}</Link>
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant="body1">{TimeUtil.ago(project.updated)}</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant="body1">{project.stats.numberOfTrainingRows}</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant="body1">{project.stats.numberOfValidationRows}</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant="body1">{project.stats.numberOfCustomModels}</Typography>
                            </TableCell>
                            <TableCell>
                                <ul>
                                    {project.columns.map(column =>
                                        <li>
                                            <Typography variant="body1">{column.name}</Typography>
                                        </li>,
                                    )}
                                </ul>
                            </TableCell>
                        </TableRow>,
                    )}
                </TableBody>
            </Table>
            </>
    );
}

export default AdminProjectsTable;
